import moment from 'moment';
import { useContext } from 'react';
import styled from 'styled-components';
import Title from '../../../components/Title';
import FormBlock from './FormBlock';
import BlockedScreen from './BlockedScreen';
import Button from '../../../components/Button';
import { DivFooter, LetterAvatar, ParentalConsentContext } from '../index';
import { UnderageUserStatus } from '../../../types/underageUser';
import Description from '../../../components/Description';
import { Actions, Categories } from '../../../types/gtm';
import { useAuth } from '../../../hooks/useAuth';

const getFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase();
};

const UnderageUserData = styled.div`
  padding: 48px 0;
  display: flex;
  justify-content: left;
  width: 100%;
`;

const Name = styled.div`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.2px;
  font-weight: 700;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  color: #333333;
  letter-spacing: -0.6px;
`;

const DivLabel = styled.div`
  font-size: 16px;
  line-height: 16px;
  letter-spacing: normal;
  font-weight: 500;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  color: #333333;
  margin-top: 4px;
`;

const ParentalManagementCard = styled.div`
  border: 1px solid #d8d8d8;
  box-shadow: 0px 1px 2px rgb(0 0 0 / 5%);
  background: #ffffff;
  border-radius: 3px;
  padding: 24px;
  line-height: 1.5;
  border-radius: 16px;
  > div {
    > h2 {
      font-family: 'Inter';
      font-size: 20px;
      margin: 0 0 16px 0;
    }
    &:first-child {
      margin-bottom: 16px;
      p {
        margin: 0;
      }
    }

    > ul {
      padding-left: 0;
      list-style-type: none;
      margin: 48px 0 0 0;
      > li {
        padding-bottom: 24px;
        div {
          > p {
            font-size: 12px;
            margin: 8px 0 0 0;
            color: red;
          }
        }

        .DivInput {
          margin: 0;
          padding: 24px 0 0 0;
          width: 293px;
        }
      }
    }
  }
`;

const DivDelete = styled.div`
  padding-top: 48px;
  border-top: 1px solid #dfdfdf;
  p {
    margin-bottom: 24px;
    font-size: 16px;
  }
`;

const DetailsUnderage = () => {
  const { underageUser, setStep } = useContext(ParentalConsentContext);
  const { user } = useAuth();

  function confirmDelete() {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.ParentalConsent,
      event_action: Actions.ClickDeleteAccountParental,
      event_label: underageUser.underageId,
      bd_suser_code: user?.globoId,
    });
    setStep({ screen: 'confirm', type: 'delete' });
  }

  return (
    <>
      <Title>Consentimento Parental</Title>
      <Description>
        <p>
          Tenha o controle em relação à Conta Globo do menor. É possível
          bloqueá-la ou excluí-la permanentemente.
        </p>
      </Description>
      <UnderageUserData>
        <div>
          <LetterAvatar>{getFirstLetter(underageUser.name)}</LetterAvatar>
        </div>
        <div>
          <Name>{underageUser?.name}</Name>
          <DivLabel>
            {underageUser?.email} | Conta autorizada em{' '}
            {moment(underageUser?.authorizationAt).format('DD/MM/yyyy')}
          </DivLabel>
        </div>
      </UnderageUserData>
      <ParentalManagementCard>
        {underageUser?.status === UnderageUserStatus.Unblocked && <FormBlock />}
        {underageUser?.status === UnderageUserStatus.Blocked && (
          <BlockedScreen />
        )}

        <DivDelete>
          <h2>Exclusão definitiva</h2>
          <p>
            Por meio da exclusão definitiva, você{' '}
            <b>
              revogará a autorização concedida ao menor para o uso da sua Conta
              Globo.
            </b>{' '}
            {underageUser?.name} perderá a sua conta e o acesso aos Produtos
            Globo.
          </p>
        </DivDelete>
        <DivFooter>
          <Button
            width="264px"
            onClick={() => confirmDelete()}
            variant="danger"
          >
            Excluir Conta Globo
          </Button>
        </DivFooter>
      </ParentalManagementCard>
    </>
  );
};

export default DetailsUnderage;
